import { FC } from 'react';

import { SearchConsoleUrlInspectionForm } from '@/modules/Domains';

interface Props {
  siteId: string;
  domainId: string;
}

export const SearchConsoleUrlInspectionDossierView: FC<Props> = ({ domainId, siteId }) => {
  return (
    <SearchConsoleUrlInspectionForm
      domainId={ domainId }
      siteId={ siteId }
    />
  );
};
